import { render } from "./PageSubmitComplete.vue?vue&type=template&id=30d8de32&scoped=true"
import script from "./PageSubmitComplete.vue?vue&type=script&lang=js"
export * from "./PageSubmitComplete.vue?vue&type=script&lang=js"

import "./PageSubmitComplete.vue?vue&type=style&index=0&id=30d8de32&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d8de32"]])

export default __exports__